module.exports = __webpack_public_path__ + "static/img/call_flow_keyword_routing.b5e9c631.png";